import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseProductCategory } from "./UseProductCategory";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function CategoryAutoComplete(props) {
  const { getAllCategoryList } = UseProductCategory();
  const [categoryRes, setCategoryRes] = React.useState();
  const [selectedCategory, setSelectedCategory] = React.useState();
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {
    setProgress(true);
    getAllCategoryList((productCategories) => {
      setCategoryRes(productCategories);
    });
  }, []);

  useEffect(() => {
    if (!props.selectedCategoryID) {
      setSelectedCategory();
    }
  }, [props.selectedCategoryID]);

  useEffect(() => {
    if (categoryRes && props.selectedCategoryID) {
      setSelectedCategory(
        categoryRes.productCategories.find(
          (m) => m.id == props.selectedCategoryID
        )
      );
    }
  }, [categoryRes, props.selectedCategoryID]);

  useEffect(() => {
    if (selectedCategory) {
      if (props.orderGift) {
        props.setName(selectedCategory.faName);
        props.setter({
          ...props.lvl1State,
          value: selectedCategory.id,
        });
        return;
      }
      props.setter({
        ...props.lvl1State,
        categoryID: selectedCategory.id,
      });
      if (props.Offer) {
        props.setName(selectedCategory.faName);
      }
    }
  }, [selectedCategory]);

  return categoryRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: (props.Offer || props.orderGift) && "100%",
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        value={selectedCategory ? selectedCategory : ""}
        options={
          categoryRes.productCategories ? categoryRes.productCategories : []
        }
        getOptionLabel={(productCategories) =>
          productCategories.faName ? productCategories.faName : ""
        }
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField error={props.validation} {...params} label="دسته" />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.faName ? option.faName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedCategory(newValue);
          } else {
            if (props.orderGift) {
              setSelectedCategory();
              props.setter({
                ...props.lvl1State,
                value: 0,
              });
              return;
            }
            setSelectedCategory();
            props.setter({
              ...props.lvl1State,
              categoryID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllCategoryList((productCategories) => {
            setCategoryRes(productCategories);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/categories" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
